// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCart = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M2 2h6v4h13.28l-2.5 10H6V4H2zm6 6v6h9.22l1.5-6z" />,
    <path d="M16 20a2 2 0 11-4 0 2 2 0 014 0m-6 0a2 2 0 11-4 0 2 2 0 014 0" />
  );
export default SvgIconCart;
